//fetch all departments list from API
import API_CONFIG from '../config/apiConfig';

function getToken() {
  const user = localStorage.getItem('user');
  if (!user) return null;
  try {
    return JSON.parse(user).token;
  } catch {
    return null;
  }
}
export async function fetchDepartments() {
  const token = getToken();
  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}/departments`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  
    if (!response.ok) throw new Error('Failed to fetch departments');
    return await response.json();
  } catch (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }
}
